import React, { useEffect, useState, useRef, useMemo } from "react";

import {

    IconPlus,

} from "@tabler/icons-react";
import { FiEdit } from "react-icons/fi";
import { RiListRadio, RiDeleteBin2Line } from "react-icons/ri";
import ReactQuill from "react-quill";
import TestImage from "../../assest/gallery.png";
import { addAliumniLatestNews, deleteNewsData, editAlumniData, getAlumniNewsData, } from "../../controllers/alumniLatestNews.controller"
import toast from 'react-hot-toast';
import NewsCard from "./NewsCard";
import { clsx } from "clsx";
import Page from "../../Components/Page";
import Button from "../../Components/Button";




const AlumniLatestNews = ({ imageUrl, title, description, onEdit, onDelete }) => {
    const [modalData, setModalData] = useState({ index: null, value: "" });
    const [previewValues, setPreviewValues] = useState([]);
    const [image, setImage] = useState(null);
    const [message, setMessage] = useState("");
    const [isModalOpenAdd, setisModalOpenAdd] = useState(false);
    const [isModalOpenEdit, setisModalOpenEdit] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [titleData, setTitleData] = useState('');
    const [data, setData] = useState([])
    const [newsData, setNewsData] = useState([]);
    const [selectedNewsId, setSelectedNewsId] = useState(null);
    const [filterData, setFilterData] = useState({
        currentPage: 1,
        categoryId: "",
        itemName: "",
    });

    const addTitleRef = useRef();
    const addDescriptionRef = useRef();
    const editTitleRef = useRef();
    const editDescriptionRef = useRef();

    const handlePreviewChange = (index, field, value) => {
        const updatedValues = [...previewValues];
        updatedValues[index][field] = value;
        setPreviewValues(updatedValues);
    };

    // const handleImageChange = (event) => {
    //     const file = event.target.files[0];
    //     if (file) {
    //         setImage(URL.createObjectURL(file));
    //     }
    // };


    const fetchAlumniData = async () => {
        const res = await getAlumniNewsData({})
        console.log('res => ', res)

        if (res.status === 200) {
            const apiData = res?.data?.data;
            const cardData = apiData?.map((d) => ({
                id: d.alumniNews_id,
                image: d.images[0],
                title: d.alumniNews_title,
                description: d.alumniNews_description,
            }))
            setNewsData(cardData)
        }
    }

    useEffect(() => {
        fetchAlumniData()
    }, [])



    const modules = {
        toolbar: [
            [{ header: [1, 2, 3, false] }], // Heading styles
            [{ font: [] }],   // Font selection
            ["bold", "italic", "underline"], // Font styles
            [{ align: [] }], // Alignment options
            ["clean"], // Clear formatting
        ],
    };

    const formats = [
        "font",
        "header",
        "bold",
        "italic",
        "underline",
        "align",
    ];

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        handleFileSelected(file);
    };


    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        handleFileSelected(file);
    };


    const handleFileSelected = (file) => {
        if (file) {
            if (file.size > 1024 * 1024) {  // 1MB limit
                toast.error("File size exceeds 1MB.");
                return;
            }
            setImage(URL.createObjectURL(file));
            setSelectedFile(file);
        } else {
            setSelectedFile(null);
        }
    };

    const removeImage = () => {
        setImage(null);
        setSelectedFile(null);
    }

    const addAlLatestNews = async () => {
        try {

            const title = addTitleRef.current.value?.trim();
            const description = addDescriptionRef.current.getEditorContents();

            console.log('data => ', title, ' => ', description)

            if (!title || !description || !selectedFile) {
                toast.error("Please fill in all the required fields and upload an image.");
                return;
            }

            toast.loading("Submitting your data...");

            const res = await addAliumniLatestNews({ file: selectedFile, title, description });
            console.log("resqqq", res);

            const message = res.data.message;
            toast.dismiss();
            if (res.status === 200) {
                toast.success("Alumni News added successfully!");


                setImage(null);
                setSelectedFile(null);
                addTitleRef.current.value = "";
                addDescriptionRef.current.getEditor().setContents([]);


                // setisModalOpenAdd(false);
                fetchAlumniData();
            } else {
                toast.error(message || "Failed to add alumni news.");
            }
        } catch (error) {
            toast.dismiss();
            console.error("Error adding alumni news:", error);

            // Show error message
            const message = error?.response?.data?.message || "Something went wrong!";
            toast.error(message);
        }
    };

    const deleteNews = async () => {
        try {
            if (selectedNewsId) {
                toast.loading("Please wait...");
                const res = await deleteNewsData({ id: selectedNewsId })
                const message = res.data.message;
                toast.dismiss();
                if (res.status === 200) {
                    toast.success(message);
                    fetchAlumniData()
                    document.getElementById("modal-delete").close()
                } else {
                    toast.error(message);
                }
            }
        } catch (error) {
            console.error(error);
            const message = error?.response?.data?.error || "Something went wrong!";
            toast.dismiss();
            toast.error(message);
        }
    }

    // const handleImageChange = (event) => {
    //     const file = event.target.files[0];
    //     if (file) {
    //         setImage(URL.createObjectURL(file));
    //         setSelectedFile(file)
    //     } else setSelectedFile(null)

    // };

    const {
        page: currentPage = null,
        totalPages = null,
        totalItems = null,
    } = data?.pagination || {};

    // pagination
    const btnPaginationFirstPage = () => {
        setFilterData((ps) => ({ ...ps, currentPage: 1 }));
    };
    const btnPaginationLastPage = () => {
        setFilterData((ps) => ({ ...ps, currentPage: totalPages }));
    };
    const btnPaginationNextPage = () => {
        if (currentPage == totalPages) {
            return;
        }
        setFilterData((ps) => ({ ...ps, currentPage: currentPage + 1 }));
    };
    const btnPaginationPreviousPage = () => {
        if (currentPage == 1) {
            return;
        }
        setFilterData((ps) => ({ ...ps, currentPage: currentPage - 1 }));
    };
    // pagination 


    const [toggles, setToggles] = useState([
        { label: 'Add New', icon: <IconPlus />, isToggled: false },
        { label: 'List', icon: <RiListRadio />, isToggled: true },
    ]);

    const handleToggle = (index) => {
        setToggles((prevToggles) =>
            prevToggles.map((toggle, i) => ({ ...toggle, isToggled: i === index }))
        );
    };

    const toggeledIndex = useMemo(() => {
        return toggles.findIndex((d) => d.isToggled)
    }, [toggles])



    
    const handleRemoveImage = () => {
        setImage(null);
        setSelectedFile(null);
    };

    const editAlLatestNews = async () => {
        try {

            const title = editTitleRef.current.value?.trim();
            const description = editDescriptionRef.current.getEditorContents();

            console.log('data => ', title, ' => ', description)

            if (!title || !description) {
                toast.error("Please fill in all the required fields and upload an image.");
                return;
            }

            toast.loading("Submitting your data...");

            const res = await editAlumniData({ id:selectedNewsId, file: selectedFile, title, description });
            console.log("res edit data", res);

            const message = res.data.message;
            toast.dismiss();
            if (res.status === 200) {
                toast.success("Alumni News added successfully!");
                document.getElementById("modal-edit").close()

                setImage(null);
                setSelectedFile(null);
                editTitleRef.current.value = "";
                editDescriptionRef.current.getEditor().setContents([]);
                fetchAlumniData();

            } else {
                toast.error(message || "Failed to add alumni news.");
            }
        } catch (error) {
            toast.dismiss();
            console.error("Error adding alumni news:", error);

            // Show error message
            const message = error?.response?.data?.message || "Something went wrong!";
            toast.error(message);
        }
    };
   

    return (
        <Page className="px-8 py-6">
            <div>

                <div className='flex text-xl gap-10 items-center'>
                    <div className="text-[#100f13]">
                        Alumni / <span className="text-[black] bg-white mt-6">Alumni Latest News</span>
                    </div>
                </div>

                <div className="flex flex-wrap gap-4 mt-4">
                    {toggles.map((toggle, index) => (
                        <div key={toggle.id} className="flex flex-col items-center">

                            <Button styles={'h-100'} outlined={!toggle.isToggled} onClick={() => handleToggle(index)}>
                                <span className="flex flex-row items-center justify-center w-[150px]">{toggle.icon} {toggle.label}</span>
                            </Button>

                        </div>
                    ))}
                </div>

                {toggeledIndex === 1 ? (
                    <>
                        <div className="flex flex-col items-center justify-center w-full h-full p-6">
                            <div className="grid gap-4 w-full max-w-2xl">
                                {newsData.map((news) => (
                                    <NewsCard key={news.id} news={news}
                                        onDelete={(id) => {
                                            setSelectedNewsId(id)
                                            document.getElementById("modal-delete").showModal()
                                        }}
                                        onEdit={(data) => {
                                            setSelectedNewsId(data.id)
                                            editTitleRef.current.value = data.title;
                                            editDescriptionRef.current.getEditor().clipboard.dangerouslyPasteHTML(data.description);
                                            setImage(data.image)
                                            document.getElementById("modal-edit").showModal()
                                        }}
                                    />
                                ))}
                            </div>
                        </div>
                    </>
                )
                    :
                    <>
                        <div className="p-6 bg-white rounded-lg shadow-md mb-10">

                            <h1 className="text-xl font-bold text-gray-700 mb-4">Add Alumni Latest News</h1>

                            <div className="mb-4">
                                <label className="block text-gray-600 mb-2">Title</label>
                                <input
                                    ref={addTitleRef}
                                    type="text"
                                    className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:[#92288C]"
                                />
                            </div>

                            <div className="grid grid-cols-2 gap-6">

                                <div className="mt-6">
                                    <h1 className="block text-black font-medium mb-2 text-[18px]">
                                        Logo <b className="text-[#4B465C]">(Accept: .jpg, .png)</b>
                                    </h1>
                                    <div className="flex flex-col items-center justify-center border-dashed border-2 border-gray-300 rounded-lg h-36" onDragOver={handleDragOver} onDrop={handleDrop}>
                                        {/* {image ? (
                                            <>
                                            <img src={image} alt="Uploaded Preview" className="h-28 w-auto object-contain" />
                                            <button onClick={handleRemoveImage}>Remove Image</button>
                                            </>
                                        ) : (
                                            <div className="text-gray-500">
                                                <div className="flex justify-center">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        strokeWidth={1.5}
                                                        stroke="currentColor"
                                                        className="w-10 h-10"
                                                    >
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                                                    </svg>
                                                </div>
                                                <p>Drag and drop image here</p>
                                                <p className="text-sm text-center text-gray-400">
                                                    Any size of image, will automatically adjust to the frame 
                                                </p>
                                                <label className="text-[#92288C] cursor-pointer">
                                                    <input
                                                        type="file"
                                                        accept=".jpg, .png"
                                                        onChange={handleImageChange}
                                                        className="hidden"
                                                    />
                                                    Browse image
                                                </label>
                                            </div>
                                        )} */}
                                       {image ? (
                                            <div className="relative">
                                                <img
                                                    src={image}
                                                    alt="Uploaded Preview"
                                                    className="object-contain w-auto h-28"
                                                />
                                                <button
                                                    onClick={removeImage}
                                                    className="absolute top-0 right-0 p-1 text-red-500 bg-white rounded-full hover:text-red-700 focus:outline-none focus:ring-2 focus:ring-red-500"
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
                                                        <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                                                    </svg>
                                                </button>
                                            </div>
                                        ) : (
                                            <div className="text-gray-500">
                                                <div className="flex justify-center">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        strokeWidth={1.5}
                                                        stroke="currentColor"
                                                        className="w-10 h-10"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            d="M12 4.5v15m7.5-7.5h-15"
                                                        />
                                                    </svg>
                                                </div>
                                                <p>Drag and drop image here</p>
                                                <p className="text-sm text-center text-gray-400">
                                                    Maximum file size is 1MB
                                                </p>
                                            </div>
                                        )}
                                        <label className="text-[#92288C] cursor-pointer">
                                            <input
                                                type="file"
                                                accept=".jpg, .png,.webp"
                                                onChange={handleImageChange}
                                                className="hidden"
                                            />
                                            Browse image
                                        </label>
                                    </div>
                                </div>


                                <div>
                                    <label htmlFor="goal" className="block text-gray-700 font-medium">Description</label>
                                    <div className="h-full overflow-hidden border border-gray-300 rounded-md focus-within:border-gray-400">

                                        <ReactQuill
                                            ref={addDescriptionRef}
                                            id="message"
                                            theme="snow"
                                            modules={modules}
                                            formats={formats}
                                            className="h-[300px]"
                                            placeholder="Enter your message here..."
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="mt-8 flex justify-end">
                                <button
                                    type="button"
                                    onClick={() => addAlLatestNews()}
                                    className="flex text-xl gap-1 items-center bg-[#92288C] text-white py-2 px-4 rounded-lg hover:bg-[#92288C] focus:outline-none focus:ring-2 pl-10 w-[150px] h-100"
                                >
                                    <IconPlus />  Add
                                </button>
                            </div>
                        </div>
                    </>
                }
            </div>

            <dialog
                id="modal-edit"
                className="modal modal-bottom sm:modal-middle inset-0 z-50 rounded-lg"
            >
                <div className="p-6 bg-white rounded-lg shadow-md mb-10">

                    <h1 className="text-xl font-bold text-gray-700 mb-4">Edit Alumni Latest News</h1>

                    <div className="mb-4">
                        <label className="block text-gray-600 mb-2">Title</label>
                        <input
                            ref={editTitleRef}
                            type="text"
                            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:[#92288C]"
                        />
                    </div>

                    <div className="grid grid-cols-2 gap-6">

                        <div className="mt-6">
                            <h1 className="block text-black font-medium mb-2 text-[18px]">
                                Logo <b className="text-[#4B465C]">(Accept: .jpg, .png)</b>
                            </h1>
                            <div className="flex flex-col items-center justify-center border-dashed border-2 border-gray-300 rounded-lg h-36" onDragOver={handleDragOver} onDrop={handleDrop}>
                                {/* {image ? (
                                      <>
                                      <img src={image} alt="Uploaded Preview" className="h-28 w-auto object-contain" />
                                      <button onClick={handleRemoveImage}>Remove Image</button>
                                      </>
                                ) : (
                                    <div className="text-gray-500">
                                        <div className="flex justify-center">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                strokeWidth={1.5}
                                                stroke="currentColor"
                                                className="w-10 h-10"
                                            >
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                                            </svg>
                                        </div>
                                        <p>Drag and drop image here</p>
                                        <p className="text-sm text-center text-gray-400">
                        Any size of image, will automatically adjust to the frame 
                        </p>
                                        <label className="text-[#92288C] cursor-pointer">
                                            <input
                                                type="file"
                                                accept=".jpg, .png"
                                                onChange={handleImageChange}
                                                className="hidden"
                                            />
                                            Browse image
                                        </label>
                                    </div>
                                )} */}
                                {image ? (
                                    <div className="relative">
                                        <img
                                            src={image}
                                            alt="Uploaded Preview"
                                            className="object-contain w-auto h-28"
                                        />
                                        {/* <button
                                            onClick={removeImage}
                                            className="absolute top-0 right-0 p-1 text-red-500 bg-white rounded-full hover:text-red-700 focus:outline-none focus:ring-2 focus:ring-red-500"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
                                                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                                            </svg>
                                        </button> */}
                                    </div>
                                ) : (
                                    <div className="text-gray-500">
                                        <div className="flex justify-center">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                strokeWidth={1.5}
                                                stroke="currentColor"
                                                className="w-10 h-10"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    d="M12 4.5v15m7.5-7.5h-15"
                                                />
                                            </svg>
                                        </div>
                                        <p>Drag and drop image here</p>
                                        <p className="text-sm text-center text-gray-400">
                                            Maximum file size is 1MB
                                        </p>
                                    </div>
                                )}
                                <label className="text-[#92288C] cursor-pointer">
                                    <input
                                        type="file"
                                        accept=".jpg, .png,.webp"
                                        onChange={handleImageChange}
                                        className="hidden"
                                    />
                                    Browse image
                                </label>
                            </div>
                        </div>


                        <div>
                            <label htmlFor="goal" className="block text-gray-700 font-medium">Description</label>
                            <div className="h-full overflow-hidden border border-gray-300 rounded-md focus-within:border-gray-400">

                                <ReactQuill
                                    ref={editDescriptionRef}
                                    id="message"
                                    theme="snow"
                                    modules={modules}
                                    formats={formats}
                                    className="h-[300px]"
                                    placeholder="Enter your message here..."
                                />
                            </div>
                        </div>
                    </div>

                    <div className="mt-8 flex justify-end gap-6">
                        <button
                            type="button"
                            className="px-6 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
                            onClick={() => {
                                setSelectedNewsId(null)
                                setImage(null)
                                setSelectedFile(null)
                                document.getElementById("modal-edit").close()
                            }}
                        >
                            Back
                        </button>
                        <button
                            onClick={() => editAlLatestNews()}
                            className="flex text-xl gap-1 items-center bg-[#92288C] text-white py-2 px-4 rounded-lg hover:bg-[#92288C] focus:outline-none focus:ring-2 pl-8 w-[150px] h-100"
                        >
                            <IconPlus />  Save
                        </button>
                    </div>
                </div>

            </dialog>

            <dialog
                id="modal-delete"
                className="modal modal-bottom sm:modal-middle inset-0 z-50 rounded-lg"
            >

                <div className="relative bg-white rounded-lg shadow-lg p-6 max-w-lg w-full mx-auto z-10">
                    <div className="text-center">
                        <h2 className="text-xl font-bold text-gray-900">
                            Delete
                        </h2>
                        <p className="text-gray-500 font-bold">
                            Are you sure?
                        </p>
                    </div>


                    <div className="mt-4 flex justify-center space-x-4">
                        <button
                            onClick={() => {
                                setSelectedNewsId(null)
                                document.getElementById("modal-delete").close()
                            }}
                            className="rounded-lg hover:bg-gray-200 transition active:scale-95 hover:shadow-lg px-6 py-3 bg-gray-200 text-gray-600"
                        >
                            No
                        </button>
                        <button
                            onClick={async () => {
                                deleteNews()
                                // deleteSliderRow();
                            }}
                            className="rounded-lg transition active:scale-95 hover:shadow-lg px-6 py-3 bg-[#92288C] text-white"
                        >
                            Yes
                        </button>
                    </div>
                </div>
            </dialog>

        </Page>



    );
};

export default AlumniLatestNews;
